'use client';

import type { FC } from 'react';
import { formatCreditsNumber } from '../utils/formatters';
import { useCountUp } from '../hooks/useCountUp';

interface BonusCreditsCountUpProps {
  amount: number;
}

/** Numeric count-up for `<BonusCredits animateChange>` — mounted only behind that flag,
 *  so every other `BonusCredits` caller (list rows, quest tiles, case cards) pays no
 *  extra hook, matching how `Credits`' `animateChange` only mounts `CreditsChangeFlash`.
 *
 *  The tween itself lives in `useCountUp`, shared with the credits balance so both
 *  readouts move at the same pace. */
export const BonusCreditsCountUp: FC<BonusCreditsCountUpProps> = ({ amount }) => {
  const displayed = useCountUp(amount);

  return <>{formatCreditsNumber(displayed)}</>;
};
